import React from 'react';
import JobCategories from '@/assets/data/job-categories.json'
import Link from 'next/link';

const JobTypes = () => {
    return (
        <section id="job_types" className='max-w-7xl px-2 md:px-8 pt-10 m-auto'>
            <div className="job-types-wrap">
                <div className="text-3xl sm:text-2xl font-bold pb-[3%]">
                    Hyqoo Experts
                </div>

                <div className="grid grid-cols-6 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-2">
                    {(JobCategories || [])?.map((category) => (
                        <div key={category?.title}>
                            <div className="text-md text-[#eb532e] font-semibold pb-[15px] ">
                                <Link aria-label={category?.title} href={category?.link} rel="noopener noreferrer">
                                    {category?.title}
                                </Link>
                            </div>
                            {category?.jobs.map((job) => (
                                <p className='w-[85%] pb-[10px] text-md text-secondary ' key={job}>{job}</p>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default JobTypes;
